import { request } from "./HttpService";
import { properties } from "../properties";
import { ftOAuthReturn } from "../constants/Constants";

// What AI apps (Claude, etc.) add as a custom connector / MCP server URL
export const mcpServerUrl = properties.host + "/mcp";
// Adds it to Claude Code; then /mcp -> deepthought -> Authenticate signs in
export const claudeCodeCommand = `claude mcp add --transport http deepthought ${mcpServerUrl}`;

const CONSENT_PATH = "/oauth/authorize";
// A sign-in that takes longer than this has wandered off; don't bounce it back
const RETURN_MAX_AGE_MS = 30 * 60 * 1000;

/**
 * The consent page sends signed-out visitors to /login; this remembers it so
 * the sign-in (or a new sign-up) returns there instead of the dashboard.
 * sessionStorage, so it stays in the tab the connection started in.
 */
export function rememberConsentPage() {
    try {
        sessionStorage.setItem(ftOAuthReturn, JSON.stringify({
            path: window.location.pathname + window.location.search,
            at: Date.now(),
        }));
    } catch { /* storage blocked: the user lands on the dashboard instead */ }
}

/** The consent page to return to after signing in, if one is pending. Consumes it. */
export function takeConsentReturn() {
    try {
        const saved = JSON.parse(sessionStorage.getItem(ftOAuthReturn));
        sessionStorage.removeItem(ftOAuthReturn);
        const fresh = saved && Date.now() - saved.at < RETURN_MAX_AGE_MS;
        // Only ever our own consent page, so this can't become an open redirect
        return fresh && typeof saved.path === "string" && saved.path.startsWith(CONSENT_PATH + "?")
            ? saved.path
            : null;
    } catch {
        return null;
    }
}

/** Who is asking for access ({clientName, redirectHost}); rejects if the request is invalid. */
export function getOAuthClient(clientId, redirectUri) {
    const query = new URLSearchParams({ client_id: clientId || "", redirect_uri: redirectUri || "" });
    return request("GET", "/oauth/client?" + query);
}

/** The user's decision; resolves to {redirectUrl} to send the browser to. */
export function decideOAuth(params, approve) {
    return request("POST", "/oauth/authorize", { ...params, approve });
}

export function getConnectedApps() {
    return request("GET", "/oauth/grants");
}

export function disconnectApp(id) {
    return request("DELETE", `/oauth/grants/${id}`);
}
